import { useState } from "react";
import { PauseCircle, PlayCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const DURATIONS = [7, 30, 60, 90];

export function ChatPauseControl({ active, onChanged }) {
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  if (!active?.contact_id) return null;
  const status = active.status;

  const call = async (fn, ok) => {
    setBusy(true);
    try {
      const { data } = await fn();
      onChanged?.(data);
      toast.success(ok);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Operazione non riuscita"); }
    finally { setBusy(false); setOpen(false); }
  };
  const pause = (days) => call(() => api.post(`/chat/${encodeURIComponent(active.phone)}/pause`, { days }), `Cliente in pausa per ${days} giorni`);
  const resume = () => call(() => api.post(`/chat/${encodeURIComponent(active.phone)}/resume`), "Cliente riattivato: riceverà di nuovo le comunicazioni");

  if (status === "paused" || status === "unsubscribed") {
    return (
      <button type="button" onClick={resume} disabled={busy} data-testid="chat-resume-button"
              title={status === "paused" ? "Termina la pausa e riattiva il cliente" : "Riattiva il cliente disiscritto (solo con il suo consenso esplicito)"}
              className="inline-flex items-center gap-1 rounded-full border border-[#10B981]/40 text-[#10B981] hover:bg-[#10B981]/10 px-2 py-0.5 text-[10px] font-semibold transition-colors shrink-0">
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <PlayCircle className="h-3 w-3" />} Riattiva
      </button>
    );
  }
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" disabled={busy} data-testid="chat-pause-button" title="Sospendi gli invii promozionali per un periodo"
                className="inline-flex items-center gap-1 rounded-full border border-dashed border-[#334155] text-slate-400 hover:text-[#F59E0B] hover:border-[#F59E0B] px-2 py-0.5 text-[10px] transition-colors shrink-0">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <PauseCircle className="h-3 w-3" />} Pausa
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-48 p-1.5 bg-[#111827] border-[#1F2937] text-slate-100" data-testid="chat-pause-popover">
        <p className="text-[11px] text-slate-500 px-2 py-1">Nessuna campagna per…</p>
        {DURATIONS.map((d) => (
          <button key={d} type="button" onClick={() => pause(d)} data-testid={`chat-pause-days-${d}`}
                  className="w-full text-left px-2 py-1.5 rounded text-xs text-slate-200 hover:bg-[#1F2937] flex items-center gap-1.5">
            <PauseCircle className="h-3 w-3 text-[#F59E0B]" /> {d} giorni
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
